const vodTypes = ['wav', 'mp4', 'srt', 'm4a'];

const docTypes = ['txt', 'doc', 'docx', 'pdf', 'ppt', 'xls', 'xlsx'];

export { vodTypes, docTypes };
